import React from "react";
import GraduationCap from "../../../assets/images/fi-rr-graduation-cap.svg";
import PdfFileImage from "../../../assets/images/pdfFile.png";
import { DATE_FORMAT3 } from "../../../constants/stringConstants";
import { DateFormatter, openImageInBrowser } from "../../../functions/commons";
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import { isEmpty, isNil } from "lodash";
import { Image } from "antd";

function ProfileCompletionExperienceDiv({experience,onEdit}) {
  console.log({experience})
  
  return ( 
    <>
    
      <div className="c1-education-div__logo-text-img" >
        <img src={GraduationCap} alt="graduation-cap" /> 

        <div className="c1ed-logo-text-img__text-img">

<div style={{display:'flex'}}>
          {experience.jobTitle&&<h3>{experience.jobTitle}</h3>
          } 
            <div onClick={()=>onEdit(experience)} className="edit_icon" style={{marginLeft:'40px'}}><ModeEditOutlineOutlinedIcon style={{height:'20px',width:'20px'}}/> </div>

          </div> 
       {experience?.companyName?.companyName &&   <h4>{ experience?.companyName?.companyName}</h4>
       }
    <p>
            {`${DateFormatter(experience.from,DATE_FORMAT3)} - ${DateFormatter(experience.to,DATE_FORMAT3)}`}
          </p>
      
          {!isNil(experience.experienceLetter)&&!isEmpty(experience.experienceLetter) && <Image src={PdfFileImage} style={{height:'70px',width:'70px'}}  preview={false}
          onClick={()=>openImageInBrowser(experience.experienceLetter)}
          
          />}


        </div>

      </div>

    </>
  );
}

export default ProfileCompletionExperienceDiv;
